<template>
  <div>
    <a-popconfirm
      class="append-to-body"
      title="删除以后不可恢复, 是否继续?"
      placement="bottomRight"
      @confirm="onRemove"
    >
      <hmd-empty-link :loading="loading">删除</hmd-empty-link>
    </a-popconfirm>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { BizFileService } from "@/core";
import { notifyEmitter } from "@/utils/emitter";

export default defineComponent({
  name: "DeleteBtn",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  emits: {
    refresh: null,
  },
  setup(props, { attrs, slots, emit }) {
    const { run, loading } = BizFileService.useDeleteApi();

    const onRemove = async () => {
      const res = await run([props.id]);
      if (res.respCode === "0000") {
        emit("refresh", null);
        //通知其他页面上传附件成功了
        notifyEmitter.emit("upload-file-success", "");
      }
    };

    return { loading, onRemove };
  },
});
</script>
